<div class="selected-wrapper">
    <div class="toolbar">
        <div class="title">Selected Specimens</div>

        <div class="actions">
            <button mat-stroked-button (click)="addMore()">
                <mat-icon>add</mat-icon>
                Add / Select
            </button>

            @if(editable){
            <button mat-stroked-button color="warn" (click)="deleteSelected()"
                [disabled]="selection.selected.length === 0">
                <mat-icon>delete</mat-icon>
                Remove selected
            </button>
            }
        </div>
    </div>

    @if(dataSource.data.length === 0){
    <div class="empty">No specimen selected yet.</div>
    } @else {
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0">

        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="toggleAllRows()" [checked]="isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(row)"
                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Type</th>
            <td mat-cell *matCellDef="let row">{{ getType(row) }}</td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">{{ getStatus(row) }}</td>
        </ng-container>

        <ng-container matColumnDef="receivedTime">
            <th mat-header-cell *matHeaderCellDef>Received</th>
            <td mat-cell *matCellDef="let row">
                <div class="g-just-flex flex-column align-items-start">
                    <span>{{ row.receivedTime | date : 'mediumDate' | na }}</span>

                </div>
                <div class="bottom subtitle-text-color-2">
                    <span>{{ row.receivedTime | date : 'shortTime' | na }}</span>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
    </table>
    }
</div>